export default __webpack_public_path__ + "locales/nl/ChangePasswordDialog.json?hash=3c82efb596b46c7deb91f2816efacde5";